import { render, staticRenderFns } from "./CreateEnvironment.vue?vue&type=template&id=b56fcdee&"
import script from "./CreateEnvironment.vue?vue&type=script&lang=js&"
export * from "./CreateEnvironment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports